export default "__VITE_ASSET__fe4ddb34__"